<div class="static-container">
  <h4>
    Refund Policy
  </h4>

    <div class="mb-5">
      <p class="gray-text">
        All sales are final and no refund will be issued.
      </p>
    </div>

    <div class="mb-5">
      <p class="heading-color">
        <strong>Questions</strong>
      </p>
      <p class="gray-text ps-4">
        If you have any questions concerning our return policy, please contact us at:
        <a href="mailto:support@djmixinglab.com">
          support&#64;djmixinglab.com
        </a>
      </p>
    </div>
</div>

